import { SQLDBInterface } from "./sql.db.interface";

export class CordovaDB implements SQLDBInterface {
    private sqliteDB: any;

    constructor(dbName: string) {
        // androidDatabaseProvider: 'system' avoids the multiple-SQLite corruption
        // problem on Android when multiple plugins access the same DB file.
        // location: 'default' is required (numeric 0/1/2 values are deprecated).
        const params = {
            name: dbName,
            location: "default",
            androidDatabaseProvider: "system"
        };

        if (!window.sqlitePlugin) {
            console.error("[CordovaDB] window.sqlitePlugin is not available — cordova-sqlite-storage plugin not loaded");
            return;
        }

        try {
            this.sqliteDB = window.sqlitePlugin.openDatabase(params);
        } catch (error) {
            console.error("[CordovaDB] Open database ERROR: " + JSON.stringify(error));
        }

        console.log("[CordovaDB] constructor done, sqliteDB = ", this.sqliteDB);
    }

    private assertReady(method: string): void {
        if (!this.sqliteDB) {
            throw new Error(`[CordovaDB] ${method} called but database is not open (sqlitePlugin unavailable or openDatabase failed)`);
        }
    }

    close(success: (result?: any) => void, error: (err?: any) => void): void {
        this.assertReady("close");
        this.sqliteDB.close(success, error);
    }

    deleteDatabase(dbName: String, callback: (error?: any) => void): void {
        this.assertReady("deleteDatabase");
        this.sqliteDB.deleteDatabase(dbName, callback);
    }

    transaction(callback: any, error?: any, success?: any): void {
        this.assertReady("transaction");
        this.sqliteDB.transaction(callback, error, success);
    }

    sqlBatch(queries: String[], success: (result?: any) => void, error: (err?: any) => void): void {
        this.assertReady("sqlBatch");
        this.sqliteDB.sqlBatch(queries, success, error);
    }

    executeSql(query: String, params: any[], success: (result?: any) => void, error: (err?: any) => void): void {
        this.assertReady("executeSql");
        this.sqliteDB.executeSql(query, params, success, error);
    }

    readTransaction(callback: (executor: any) => void, success: (result?: any) => void, error: (err?: any) => void): void {
        this.assertReady("readTransaction");
        this.sqliteDB.readTransaction(callback, success, error);
    }
}
